/*
 *
 * TestTypes constants
 *
 */

export const SLICE_NAME = 'testTypes';
